import { Box, Button } from "@mui/material"
import { useDialog } from "lib/@hooks/useDialog"
import Iconify from "minimals-template/components/Iconify"
import { PagingComponent } from "lib/@components/paging"
import { RolesDialog } from "./components/roles-dialog"

import { createRole, getPagedRoles } from "lib/permissions/roles"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { PagingSearchBarLeft } from "slot-definitions"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { RolesTable } from "routes/client-admin/plugins/permissions/client-roles/components/roles-table"

export function ClientRoleConfiguration({ selectableDemands, type }) {
    const create = useDialog(<RolesDialog />)
    const { clientId } = useBoundContext()

    return (
        <Box mt={4}>
            <PagingSearchBarLeft.Plug>
                <Box mx={1}>
                    <Button
                        data-cy="client-admin-add-role-button"
                        startIcon={<Iconify icon="mdi:account-lock" />}
                        variant="contained"
                        color="primary"
                        onClick={onConfirm}
                        sx={{ mr: 2 }}
                    >
                        Add Role
                    </Button>
                </Box>
            </PagingSearchBarLeft.Plug>
            <PagingComponent
                data-cy="client-admin-roles-table"
                placeHolder={"Roles"}
                disableRowsPerPage={true}
                query={getPagedRoles}
                component={RolesTable}
                selectableDemands={selectableDemands}
                searchItemName="role"
                top={true}
                bottom={false}
                queryParams={{
                    ...(clientId && clientId && { client: clientId }),
                    type,
                }}
            />
        </Box>
    )

    async function onConfirm() {
        const newRole = await create()
        if (newRole) {
            const role = {
                name: newRole?.name,
                description: newRole?.description || "",
                demands: newRole?.demands,
                client: clientId,
                type,
            }

            try {
                await createRole(role)
            } catch (error) {
                console.error(error)
                errorSnackbar(error?.toString())
            }
        }
    }
}
